/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconFocusedLightning: {
  name: 'focused_lightning';
  data: string;
} = {
  name: 'focused_lightning',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M553.716 468.205 482.323 501.089 574.061 299.978 337.324 418.431 428.765 271.716 284.712 21.66 144.818 21.66 373.411 293.428 261.154 471.576 330.806 300.864 51.336 21.66 23.409 21.66 23.413 21.665 23.413 124.898 274.549 342.198 172.988 555.234 449.019 445.01 401.379 584.897 514.279 542.09 595.089 595.336z"/></svg>`,
};
